/**
 * Catalog `files[]` manifest ids are generated per authenticated user on
 * `get-all-operators-with-version` (jurisdiction + registration stakeholder).
 * Persisted snapshots must match this scope or be ignored until catalog refresh.
 */
export type ManifestScopeInput = {
  /** Registration profile stakeholder (not client "viewing as" override). */
  profileStakeholder?: string | null;
  jurisdictionCountyStateKeys?: ReadonlySet<string> | null;
};

export function buildManifestScopeKey(input: ManifestScopeInput): string {
  const stake = input.profileStakeholder?.trim() ?? "";
  const jur =
    input.jurisdictionCountyStateKeys && input.jurisdictionCountyStateKeys.size > 0
      ? [...input.jurisdictionCountyStateKeys].sort().join("|")
      : "";
  return `${stake}::${jur}`;
}

export type PersistedManifestSession = {
  manifestScopeKey?: string | null;
  entries: Record<string, { manifestFileIds?: string[] | null } | undefined>;
};

/** Last catalog snapshot for one operator when session scope still matches. */
export function persistedManifestFileIdsForOperator(
  session: PersistedManifestSession,
  operatorId: string,
  currentScopeKey: string,
): ReadonlySet<string> | undefined {
  const storedScope = session.manifestScopeKey?.trim();
  if (!storedScope || storedScope !== currentScopeKey.trim()) return undefined;
  const ids = session.entries[operatorId]?.manifestFileIds;
  if (!Array.isArray(ids) || ids.length === 0) return undefined;
  return new Set(ids.filter((id) => typeof id === "string" && id.trim()).map((id) => id.trim()));
}
